module.exports = __webpack_public_path__ + "assets/799d6efce90ea9692e3312cc7ccc1ac8.png";